import React from 'react';
import { FaArrowRight } from "react-icons/fa6";
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useDailySummary } from '../../../api/hooks/use.statistics';
import { ROUTES } from '../../../routing/routes';

const DailyStatisticsWrapper = styled.div`
	max-width: 1440px;
	width: 100%;
	padding: 0 20px;
	box-sizing: border-box;
	margin: 87px auto 142px auto;
	display: flex;
	align-items: end;
	gap: 90px;

	@media (max-width: 1200px) {
		gap: 60px;
	}

	@media (max-width: 1024px) {
		margin: 40px auto;
		gap: 55px;
	}

	@media (max-width: 768px) {
		margin: 24px auto;
		flex-direction: column;
		align-items: center;
		gap: 20px;
	}
`;

const HeadingBlock = styled.div`
	display: flex;
	flex-direction: column;
	flex-shrink: 0;

	@media (max-width: 768px) {
		width: 100%;
	}
`;

const Heading = styled.div`
	font-family: "e-Ukraine-Head", sans-serif;
	font-weight: 400;
	font-size: 48px;
	color: #555;
	white-space: nowrap;

	@media (max-width: 1024px) {
		font-size: 32px;
	}

	@media (max-width: 768px) {
		font-size: 28px;
		white-space: normal;
	}
`;

const HeadingText = styled.div`
	font-family: "e-Ukraine", sans-serif;
	font-weight: 400;
	font-size: 15px;
	color: #555;
	white-space: nowrap;

	@media (max-width: 1024px) {
		font-size: 12px;
	}

	@media (max-width: 768px) {
		white-space: normal;
	}
`;

const DailyStatisticsContent = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: end;
	width: 100%;
	min-width: 0;
`;

const DailyStatisticsList = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	min-width: 0;
	gap: 16px;
`;

const DailyStatisticsItem = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
	flex: 1 1 0;
	min-width: 0;
`;

const ItemValue = styled.div`
	font-family: "e-Ukraine-Head", sans-serif;
	font-weight: 500;
	font-size: 40px;
	color: #09723c;
	white-space: nowrap;

	@media (max-width: 1200px) {
		font-size: 32px;
	}

	@media (max-width: 1024px) {
		font-size: 28px;
	}

	@media (max-width: 530px) {
		font-size: 20px;
	}
`;

const Text = styled.div`
	font-family: "e-Ukraine", sans-serif;
	font-weight: 400;
	font-size: 14px;
	color: #555;

	@media (max-width: 1024px) {
		font-size: 11px;
	}

	@media (max-width: 530px) {
		font-size: 10px;
	}
`;

const DailyStatisticsArr = styled.div`
	border-radius: 100%;
	background: #f8f8f8;
	width: 55px;
	height: 55px;
	box-shadow: 1px 1px 2px 0 rgba(0, 0, 0, 0.25);
	display: flex;
	justify-content: center;
	align-items: center;
	flex-shrink: 0;

	@media (max-width: 768px) {
		width: 36px;
		height: 36px;
	}

	@media (max-width: 530px) {
		width: 33px;
		height: 33px;
	}
`;

const NavBlock = styled(Link)`
	gap: 8px;
	display: flex;
	flex-direction: column;
	align-items: center;
	text-decoration: none;
	flex-shrink: 0;
	margin-left: 16px;

	@media (max-width: 768px) {
		margin-left: 12px;
	}
`;

export const DailyStatisticsBlockComponent: React.FC = () => {
	const { data } = useDailySummary();

	return (
		<DailyStatisticsWrapper>
			<HeadingBlock>
				<Heading>Статистика</Heading>
				<HeadingText>(результат роботи за поточну добу)</HeadingText>
			</HeadingBlock>

			<DailyStatisticsContent>
				<DailyStatisticsList>
					<DailyStatisticsItem>
						<ItemValue>{data?.accepted}</ItemValue>
						<Text>Прийнято звернень</Text>
					</DailyStatisticsItem>
					<DailyStatisticsItem>
						<ItemValue>{data?.consultations}</ItemValue>
						<Text>Надано консультацій</Text>
					</DailyStatisticsItem>
					<DailyStatisticsItem>
						<ItemValue>{data?.executed}</ItemValue>
						<Text>Виконано звернень</Text>
					</DailyStatisticsItem>
				</DailyStatisticsList>

				<NavBlock to={ROUTES.STATISTICS}>
					<DailyStatisticsArr>
						<FaArrowRight color='#01924f' size={20} />
					</DailyStatisticsArr>
					<Text>Повний звіт</Text>
				</NavBlock>
			</DailyStatisticsContent>
		</DailyStatisticsWrapper>
	);
};